/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * Corca LaTeX Service
 * OpenAPI spec version: 0.0.0
 */
import type {
  ConverterConvertMarkdown200,
  ConverterConvertMarkdownBody,
  ImporterImportFile200,
  ImporterImportFileBody,
  LatexGenerateLatexBundleParams,
  LatexGenerateLatexParams,
  LatexGeneratePdfParams,
  LatexResponse,
} from "./latex-api.generated.schemas";

import { client } from "./client";
import { multipartFormData } from "./multipartFormData";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Converts markdown to y_doc. Used by Notion import (Rails API calls this).
 */
export const converterConvertMarkdown = (
  converterConvertMarkdownBody: ConverterConvertMarkdownBody,
  options?: SecondParameter<typeof client<ConverterConvertMarkdown200>>,
) => {
  return client<ConverterConvertMarkdown200>(
    {
      url: `/latex-api/convert/markdown`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: converterConvertMarkdownBody,
    },
    options,
  );
};

/**
 * Generate LaTeX source
 */
export const latexGenerateLatex = (
  params: LatexGenerateLatexParams,
  options?: SecondParameter<typeof client<LatexResponse>>,
) => {
  return client<LatexResponse>(
    { url: `/latex-api/generate_latex`, method: "GET", params },
    options,
  );
};

/**
 * Generate LaTeX source
 */
export const latexGenerateLatexBundle = (
  params: LatexGenerateLatexBundleParams,
  options?: SecondParameter<typeof client<Blob>>,
) => {
  return client<Blob>(
    { url: `/latex-api/generate_latex/bundle`, method: "GET", params, responseType: "blob" },
    options,
  );
};

/**
 * Generate PDF file
 */
export const latexGeneratePdf = (
  params: LatexGeneratePdfParams,
  options?: SecondParameter<typeof client<Blob>>,
) => {
  return client<Blob>(
    { url: `/latex-api/generate_pdf`, method: "GET", params, responseType: "blob" },
    options,
  );
};

export const importerImportFile = (
  importerImportFileBody: ImporterImportFileBody,
  options?: SecondParameter<typeof client<ImporterImportFile200>>,
) => {
  const formData = multipartFormData(importerImportFileBody);
  return client<ImporterImportFile200>(
    {
      url: `/latex-api/import_file`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: formData,
    },
    options,
  );
};

export type ConverterConvertMarkdownResult = NonNullable<
  Awaited<ReturnType<typeof converterConvertMarkdown>>
>;
export type LatexGenerateLatexResult = NonNullable<Awaited<ReturnType<typeof latexGenerateLatex>>>;
export type LatexGenerateLatexBundleResult = NonNullable<
  Awaited<ReturnType<typeof latexGenerateLatexBundle>>
>;
export type LatexGeneratePdfResult = NonNullable<Awaited<ReturnType<typeof latexGeneratePdf>>>;
export type ImporterImportFileResult = NonNullable<Awaited<ReturnType<typeof importerImportFile>>>;
